import { useEffect, useState } from 'react';
import { useClickRef } from '@make-software/csprclick-ui';
import { CSPRCLICK_EVENTS } from '@make-software/csprclick-core-types';

export const useCSPRClick = () => {
  const clickRef = useClickRef();
  const [csprClickReady, setCsprClickReady] = useState(false);

  useEffect(() => {
    if (!clickRef) return;

    const onLoaded = () => setCsprClickReady(true);
    clickRef.on(CSPRCLICK_EVENTS.LOADED, onLoaded);

    if (clickRef.digestAuth) setCsprClickReady(true);

    return () => {
      clickRef.off(CSPRCLICK_EVENTS.LOADED, onLoaded);
    };
  }, [clickRef]);

  return { clickRef, csprClickReady };
};
